import { YES_OPTION } from "../constants";
import { getTranslatedContactTypeOption, getTranslatedGenderOption } from "../lists/personal";
import { getPrettyDate } from "../utils/date-utils";
import { formatYesNoDropdownLists } from "../utils/form-data-utils";

export const formatPersonalDataFormValues = (associate, language="pt") => { 

    associate.personalData.prettyBirthDate = associate.personalData.birthDate !== null ? getPrettyDate(associate.personalData.birthDate) : null;
    
    if(typeof associate.personalData.portugueseCitizen !== 'object' && associate.personalData.portugueseCitizen !== null) {
        associate.personalData.portugueseCitizen = formatYesNoDropdownLists(associate.personalData.portugueseCitizen, language);
    }
    else if (typeof associate.personalData.portugueseCitizen  === 'object' && associate.personalData.portugueseCitizen !== null) {
        associate.personalData.portugueseCitizen = formatYesNoDropdownLists(associate.personalData.portugueseCitizen.code === YES_OPTION.code, language);
    }

    if(typeof associate.personalData.district !== 'object' && associate.personalData.district !== null) {
        associate.personalData.portugueseAddress = formatYesNoDropdownLists(associate.personalData.district !== null, language);
    }
    else if (typeof associate.personalData.district  === 'object' && associate.personalData.district !== null) {
        associate.personalData.portugueseAddress = formatYesNoDropdownLists(associate.personalData.district !== null, language);
    }

    if(typeof associate.personalData.county !== 'object' && associate.personalData.newcounty !== null) {
        associate.personalData.county = { name: associate.personalData.county, code: associate.personalData.county };
    }

    if(typeof associate.personalData.district !== 'object' && associate.personalData.district !== null) {
        associate.personalData.district = { name: associate.personalData.district, code: associate.personalData.district };
    }

    if(typeof associate.personalData.preferredContact !== 'object' && associate.personalData.preferredContact !== null) {
        associate.personalData.preferredContact = { name: associate.personalData.preferredContact, code: associate.personalData.preferredContact };
    }
    else if (typeof associate.personalData.preferredContact === 'object' && associate.personalData.preferredContact !== null) {
        associate.personalData.preferredContact = getTranslatedContactTypeOption(associate.personalData.preferredContact.code, language);
    }

    if(typeof associate.personalData.nationality !== 'object' && associate.personalData.nationality !== null) {
        associate.personalData.nationality = { name: associate.personalData.nationality, code: associate.personalData.nationality };
    }

    if(typeof associate.personalData.gender !== 'object' && associate.personalData.gender !== null) {
        associate.personalData.gender = { name: associate.personalData.gender, code: associate.personalData.gender };
    }
    else if (typeof associate.personalData.gender === 'object' && associate.personalData.gender !== null) {
        associate.personalData.gender = getTranslatedGenderOption(associate.personalData.gender.code, language);
    }

    if(typeof associate.personalData.nifCountry !== 'object' && associate.personalData.nifCountry !== null) {
        associate.personalData.nifCountry = { name: associate.personalData.nifCountry, code: associate.personalData.nifCountry };
    }

    if(typeof associate.personalData.streetType !== 'object' && associate.personalData.streetType !== null) {
        associate.personalData.streetType = { name: associate.personalData.streetTypePlaceholder, code: associate.personalData.streetType };
    }

    return associate;
}

export const formatPersonalDataToService = (associate) => { 

    associate.personalData.portugueseAddress = (associate.personalData.portugueseAddress.code === YES_OPTION.code);
    associate.personalData.portugueseCitizen = (associate.personalData.portugueseCitizen.code === YES_OPTION.code);
    associate.personalData.streetType = (associate.personalData.streetType !== null) ? associate.personalData.streetType.code : null;
    associate.personalData.county = associate.personalData.county.code;
    associate.personalData.district = associate.personalData.district.code;
    associate.personalData.preferredContact = associate.personalData.preferredContact.code;
    associate.personalData.nationality = associate.personalData.nationality.code;
    associate.personalData.gender = associate.personalData.gender.code;
    associate.personalData.nifCountry = associate.personalData.nifCountry.code;
    
    // HOTFIX: server is discounting 1 hour changing the correct date
    let birthDate = null;
    if(associate.personalData.birthDate !== null) {
        birthDate = new Date(associate.personalData.birthDate);
        birthDate.setHours(15);
    }

    associate.personalData.birthDate = birthDate;

    return associate;
}